import styledComponents from 'styled-components';
import { Link } from 'react-router-dom';
import { BODY_FONT_FAMILY } from '../../views/styleConstants';
import React from 'react';

const CallbackViewFrame = styledComponents.div`
font-family: ${BODY_FONT_FAMILY};
`;

export default (bottle) => {
  bottle.factory('Link', () => Link);

  // eslint-disable-next-line no-shadow
  bottle.factory('CallbackView', ({ Link }) => ({ profile }) => (
    <CallbackViewFrame>
      {!profile && <p>Loading User...</p>}
      {profile && (
        <p>
          User Loaded!
          <Link to="/">Go Home</Link>
        </p>
      )}
    </CallbackViewFrame>
  ));
};
